import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const PortalInfoIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <line
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={19}
        y1={15}
        x2={26}
        y2={15}
        strokeLinejoin="miter"
      />
      <line
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={19}
        y1={20}
        x2={26}
        y2={20}
        strokeLinejoin="miter"
      />
      <rect
        data-color="color-2"
        x={6}
        y={13}
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        width={9}
        height={9}
        strokeLinejoin="miter"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        d="M25,4c0,1.657-1.343,3-3,3 s-3-1.343-3-3h-6c0,1.657-1.343,3-3,3S7,5.657,7,4H1v24h30V4H25z"
        strokeLinejoin="miter"
      />
    </svg>
  );
};
